import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { FolderPlus, Sparkles, Zap } from 'lucide-react';

interface ListCreationNudgeProps {
  onCreateAccount: () => void;
  onClose: () => void;
}

const ListCreationNudge: React.FC<ListCreationNudgeProps> = ({ onCreateAccount, onClose }) => {
  return (
    <Card className="max-w-md mx-auto bg-gradient-to-br from-primary/10 to-primary/5 border-primary/20">
      <CardHeader className="text-center pb-3">
        <div className="w-12 h-12 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-3">
          <FolderPlus className="w-6 h-6 text-primary" />
        </div>
        <CardTitle className="text-xl">Organize with multiple lists</CardTitle>
      </CardHeader>
      <CardContent className="text-center space-y-4">
        <p className="text-muted-foreground">
          Ready to organize your tasks better? Create a free account to unlock unlimited lists and stay super organized.
        </p>
        
        <div className="bg-background/50 rounded-lg p-3 space-y-2">
          <div className="flex items-center gap-2 text-sm">
            <Sparkles className="w-4 h-4 text-primary" />
            <span>Create unlimited task lists</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Zap className="w-4 h-4 text-primary" />
            <span>Organize by project, priority, or any way you like</span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <FolderPlus className="w-4 h-4 text-primary" />
            <span>Keep work and personal tasks separate</span>
          </div>
        </div>

        <div className="space-y-2 pt-2">
          <Button onClick={onCreateAccount} className="w-full">
            Create free account
          </Button>
          <Button variant="ghost" onClick={onClose} className="w-full text-sm">
            Stay with one list for now
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};

export default ListCreationNudge;